import { render, staticRenderFns } from "./FlotaVehiculoTable.vue?vue&type=template&id=2646adb4&"
import script from "./FlotaVehiculoTable.vue?vue&type=script&lang=js&"
export * from "./FlotaVehiculoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports